<div class="main-content content-with-side-menu coupon-details">
    <h1 class="page-header">
        <app-go-back></app-go-back> {{ "CouponDetails.Title" | translate }}
    </h1>
    <div class="row no-gutters">
        <div class="col-5 details-column">
            <div class="row no-gutters">
                <div class="col-md-12 full-width">
                    <div class="card left-coupon-side">
                        <div class="card-body text-center">
                            <div class="i-gift"></div>
                        </div>
                    </div>

                    <div class="card right-coupon-side">
                        <div class="card-body">
                            @if (item) {
                                <div class="card-text">
                                    <div class="row no-gutters">
                                        @if (isAmount) {
                                            <div class="coupon-value">
                                                {{ item.value | amount: 0 }}
                                            </div>
                                        }
                                        @if (isPercent) {
                                            <div class="coupon-value">
                                                {{ item.value }}%
                                            </div>
                                        }
                                        @if (isFreeWeeks) {
                                            <div class="coupon-value">
                                                {{ item.value }}w
                                            </div>
                                        }
                                        @if (isFreeDays) {
                                            <div class="coupon-value">
                                                {{ item.value }}d
                                            </div>
                                        }
                                        <div class="align-items-center">
                                            <div class="col code-label">
                                                @if (isAmount || isPercent) {
                                                    <div>
                                                        {{
                                                            "CouponDetails.OffLabel"
                                                                | translate
                                                        }}
                                                    </div>
                                                }
                                                @if (isFreeWeeks) {
                                                    <div>
                                                        {{
                                                            "CouponDetails.FreeWeeksLabel"
                                                                | translate
                                                        }}
                                                    </div>
                                                }
                                                @if (isFreeDays) {
                                                    <div>
                                                        {{
                                                            "CouponDetails.FreeDaysLabel"
                                                                | translate
                                                        }}
                                                    </div>
                                                }
                                            </div>
                                            <div class="col coupon-code">
                                                {{ item.code }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            @if (item) {
                                <div class="card-text mt-3">
                                    <div class="row">
                                        <div class="col-sm-4 pr-0">
                                            {{
                                                "CouponDetails.CodeLabel"
                                                    | translate
                                            }}
                                        </div>
                                        <div class="col-sm-8 bolded" hznTestId="coupon-details-code">
                                            {{ item.code }}
                                        </div>
                                    </div>
                                </div>
                            }
                            @if (item) {
                                <div class="card-text">
                                    <div class="row">
                                        <div class="col-sm-4 pr-0">
                                            {{
                                                "CouponDetails.TypeLabel"
                                                    | translate
                                            }}
                                        </div>
                                        <div class="col-sm-8 bolded" hznTestId="coupon-details-type">
                                            {{ translateType() }}
                                        </div>
                                    </div>
                                </div>
                            }
                            @if (item) {
                                <div class="card-text">
                                    <div class="row">
                                        <div class="col-sm-4 pr-0">
                                            {{
                                                "CouponDetails.UsageTypeLabel"
                                                    | translate
                                            }}
                                        </div>
                                        <div class="col-sm-8 bolded" hznTestId="coupon-details-usage-type">
                                            {{ translateUsageType() }}
                                        </div>
                                    </div>
                                </div>
                            }
                            @if (item) {
                                <div class="card-text">
                                    <div class="row">
                                        <div class="col-sm-4 pr-0">
                                            {{
                                                "CouponDetails.ValueLabel"
                                                    | translate
                                            }}
                                        </div>
                                        <div class="col-sm-8 bolded" hznTestId="coupon-details-value">
                                            @if (isAmount) {
                                                <div>
                                                    {{ item.value | amount }}
                                                </div>
                                            }
                                            @if (isPercent) {
                                                <div>
                                                    {{ item.value }} % (${{
                                                        item.maxDiscountAmount
                                                    }}
                                                    max)
                                                </div>
                                            }
                                            @if (isFreeWeeks) {
                                                <div>
                                                    {{ item.value }}
                                                    {{
                                                        "CouponDetails.Weeks"
                                                            | translate
                                                    }}
                                                </div>
                                            }
                                            @if (isFreeDays) {
                                                <div>
                                                    {{ item.value }}
                                                    {{
                                                        "CouponDetails.Days"
                                                            | translate
                                                    }}
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            }
                            @if (item) {
                                <div class="card-text">
                                    <div class="row">
                                        <div class="col-sm-4 pr-0">
                                            {{
                                                "CouponDetails.SentToLabel"
                                                    | translate
                                            }}
                                        </div>
                                        <div class="col-sm-8 bolded" hznTestId="coupon-details-sent-to">
                                            {{ item.sentTo }}
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div class="row no-gutters mt-2">
                <div class="card full-width">
                    <div class="card-body">
                        <h5 class="card-title">
                            {{ "CouponDetails.SummaryLabel" | translate }}
                        </h5>
                        @if (item && item.category) {
                            <div class="card-text">
                                <div class="row">
                                    <div class="col-sm-4">
                                        {{
                                            "CouponDetails.CategoryLabel"
                                                | translate
                                        }}
                                    </div>
                                    <div class="col-sm-8 bolded" hznTestId="coupon-details-category">
                                        {{ item.category.name }}
                                    </div>
                                </div>
                            </div>
                        }
                        @if (item) {
                            <div class="card-text">
                                <div class="row">
                                    <div class="col-sm-4">
                                        {{
                                            "CouponDetails.CreatedLabel"
                                                | translate
                                        }}
                                    </div>
                                    <div class="col-sm-8 bolded">
                                        {{ item.validFrom | bcDate }}
                                    </div>
                                </div>
                            </div>
                        }
                        @if (item) {
                            <div class="card-text">
                                <div class="row">
                                    <div class="col-sm-4">
                                        {{
                                            "CouponDetails.ValidityLabel"
                                                | translate
                                        }}
                                    </div>
                                    <div class="col-sm-8 bolded" hznTestId="coupon-details-valid-to">
                                        {{ item.validTo | bcDate }}
                                    </div>
                                </div>
                            </div>
                        }
                        @if (item && isUsed) {
                            <div class="card-text">
                                <div class="row">
                                    <div class="col-sm-4">
                                        {{
                                            "CouponDetails.UsedLabel"
                                                | translate
                                        }}
                                    </div>
                                    <div class="col-sm-8 bolded">
                                        {{ item.purchase.usedAt | bcDate }}
                                        {{ "CouponDetails.By" | translate }}
                                        {{ item.purchase.usedBy }}
                                    </div>
                                </div>
                            </div>
                        }
                        @if (item && isUsed) {
                            <div class="card-text">
                                <div class="row">
                                    <div class="col-sm-4 pr-0">
                                        {{
                                            "CouponDetails.PurchaseLabel"
                                                | translate
                                        }}
                                    </div>
                                    <div class="col-sm-8 bolded">
                                        {{ item.purchase.purchaseNumber }}
                                    </div>
                                </div>
                            </div>
                        }
                        @if (item && isUsed) {
                            <div class="card-text">
                                <div class="row">
                                    <div class="col-sm-6 bolded">
                                        <div
                                            class="btn btn-link padding-0"
                                            (click)="goToPurchaseDetails()"
                                        >
                                            {{
                                                "CouponDetails.PurchaseDetailsLabel"
                                                    | translate
                                            }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
            <div class="row no-gutters mt-2">
                <div class="card full-width">
                    <div class="card-body">
                        <h5 class="card-title">
                            {{ "CouponDetails.LegalVerbiageTitle" | translate }}
                        </h5>
                        @if (item) {
                            <div class="card-text">
                                <p>
                                    {{
                                        "CouponDetails.LegalVerbiagePart1"
                                            | translate
                                    }}
                                    {{ item.validTo | bcDate }}.
                                </p>
                                <p>
                                    {{
                                        "CouponDetails.LegalVerbiagePart2"
                                            | translate
                                    }}
                                </p>
                                <p>
                                    {{
                                        "CouponDetails.LegalVerbiagePart3"
                                            | translate
                                    }}
                                </p>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
        <div class="col-5">
            <div class="row ml-2">
                <div class="col-md-8">
                    <h6 class="history-title pl-4">
                        {{ "CouponDetails.HistoryLabel" | translate }}
                    </h6>
                </div>
            </div>
            @if (isHistoryLoading) {
                <bcu-local-spinner
                    [size]="25"
                    [visible]="isHistoryLoading"
                ></bcu-local-spinner>
            }
            <div class="row ml-2">
                @if (!isHistoryLoading) {
                    <div class="col bc-timeline">
                        <div class="timeline">
                            @for (historyItem of history; track historyItem) {
                                <div
                                    class="container right"
                                    [ngClass]="{
                                        'container-used':
                                            isHistoryTypeUsed(historyItem),
                                    }"
                                >
                                    <div class="content">
                                        <p class="font-weight-bold">
                                            {{
                                                enumTranslations.couponAction(
                                                    historyItem.eventType
                                                )
                                            }}:
                                            {{ historyItem.date | bcDate }} by
                                            {{ historyItem.user }}
                                        </p>
                                        @if (historyItem.details) {
                                            <p class="mb-0">
                                                {{
                                                    "CouponDetails.Details"
                                                        | translate
                                                }}
                                            </p>
                                        }
                                        @if (historyItem.details) {
                                            <p class="font-weight-bold mb-0">
                                                {{ historyItem.details }}
                                            </p>
                                        }
                                        @if (historyItem.reason) {
                                            <p class="mb-0">
                                                {{
                                                    "CouponDetails.Reason"
                                                        | translate
                                                }}
                                            </p>
                                        }
                                        @if (historyItem.reason) {
                                            <p class="font-weight-bold mb-0">
                                                {{ historyItem.reason }}
                                            </p>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>
</div>
